import { V1_URL } from '../constants';

import { MOKA_INVENTORY_API } from '../../constants';

export const V1_ADJUSTMENTS = `${V1_URL}/adjustment`;

export const V1_ADJUSTMENTS_NEW = `${MOKA_INVENTORY_API}/v1/ingredient-adjustment`;

export const V1_EXPORT_ADJUSTMENT = `${V1_ADJUSTMENTS_NEW}/export`;

export const V1_IMPORT_ADJUSTMENTS = `${V1_ADJUSTMENTS_NEW}/import_adjustments`;

export const V1_IMPORT_ADJUSTMENT_TEMPLATE = `${V1_ADJUSTMENTS_NEW}/import_adjustment_template`;
